import { atom } from 'recoil';
import { VatRate } from '../../domain/VatRate';

export const DEFAULT_VAT_RATE = {
  country: 'GB',
  rate: 20,
};

export const currentVatRateState = atom<VatRate | null>({
  key: 'currentVatRateState',
  default: null,
});
